import { render, staticRenderFns } from "./Multitenant.vue?vue&type=template&id=2242e1b5&scoped=true&"
import script from "./Multitenant.vue?vue&type=script&lang=js&"
export * from "./Multitenant.vue?vue&type=script&lang=js&"
import style0 from "./Multitenant.vue?vue&type=style&index=0&id=2242e1b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2242e1b5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/work/kontalk/kontalk/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
installComponents(component, {VAutocomplete,VBtn,VContainer})
